import request from '@/router/axios'


export function getPanelData(query) {
  return request({
    url: '/platformDataView/panel',
    method: 'post',
    params:query
  })
}
// 获取企业信息列表
export function getPieData(query) {
  return request({
    url: '/platformDataView/pie',
    method: 'post',
    params:query
  })
}
// 获取雷达图信息
export function getRadarData(query) {
  return request({
    url: '/platformDataView/radar',
    method: 'post',
    params:query
  })
}
// 获取企业信息列表
export function getProjectInfo(query) {
  return request({
    url: '/platformDataView/projectInfo',
    method: 'post',
    params:query
  })
}
// 获取反馈信息列表
export function getFeedBackInfo(query) {
  return request({
    url: '/platformDataView/feedBackInfo',
    method: 'post',
    params:query
  })
}
// 获取反馈信息列表
export function getLineData(query) {
  return request({
    url: '/platformDataView/line',
    method: 'post',
    params:query
  })
}
// 获取反馈信息列表
export function getProjectInfoByTimeUnit(query) {
  return request({
    url: '/platformDataView/projectInfoByTimeUnit',
    method: 'post',
    params:query
  })
}

// 获取反馈信息列表
export function getMapData(query) {
  return request({
    url: '/platformDataView/map',
    method: 'post',
    params:query
  })
}

// 获取反馈信息列表
export function getPositionProjectInfo(query) {
  return request({
    url: '/platformDataView/positionProjectInfo',
    method: 'post',
    params:query
  })
}